<div class="card-content">
  <div class="crm-card-header">
    @if (loaders.card) {
      <ngx-skeleton-loader
        style="height: 30px"
        [theme]="{
          width: '300px',
          height: '30px',
          margin: '0',
          'background-color': '#ffffff',
        }"
        [animation]="'progress-dark'"
      />
    }

    @if (card) {
      <div class="crm-card-title">
        @if (!isEditTitle) {
          <span class="crm-card-title-text">{{ card.name }}</span>
        }
        @if (isEditTitle) {
          <input type="text" class="crm-card-title-input" [formControl]="cardForm.controls.name" />
        }
      </div>
    }
    @if (!isEditTitle) {
      <div class="crm-card-actions">
        <app-icon class="icon-xm click-css" (click)="isEditTitle = true">edit</app-icon>
        <app-icon class="icon-xm click-css">share</app-icon>
      </div>
    }
    @if (isEditTitle) {
      <div class="crm-card-actions">
        <app-icon class="icon-xm click-css" (click)="onCancel()">cancel</app-icon>
        <app-icon class="icon-xm click-css" (click)="onSave()">done</app-icon>
      </div>
    }

    <app-color
      class="color-picker"
      (onValueChange)="isEditCard = true"
      [formControl]="cardForm.controls.bg_color"
      [colors]="colors"
    />
  </div>

  @if (!baseService.isMobile) {
    @if (loaders.columns) {
      <ngx-skeleton-loader [theme]="{ width: '100%', 'background-color': '#ffffff' }" animation="progress-dark" />
    }
    <div class="crm-card-columns">
      @for (column of columns; track column; let i = $index) {
        <div
          class="crm-card-column click-css"
          (focus)="onFocusColumn(column.id)"
          (mouseover)="isHoverArrow(true, column.bg_color, column.text_color, i)"
          (mouseleave)="isHoverArrow(false, column.bg_color, column.text_color, i)"
          (click)="onChangeColumn(column.id)"
        >
          <div
            class="crm-card-column-item"
            [ngClass]="{ 'crm-card-column-full': isColumnColor(column, i) }"
            [ngStyle]="columnStyle(column, i)"
          >
            <span class="text-ellipsis ps-2">{{ column.name }}</span>
          </div>
        </div>
      }
    </div>
  }

  <div class="crm-card-tabs">
    <app-tabs [tabList]="tabs" (onSelectTab)="onChangeTab($event)" />
  </div>

  @if (selectedTab) {
    @switch (selectedTab.value) {
      @case (CardTab.GENERAL) {
        <div class="crm-card-info-container">
          <div class="crm-card-info">
            <div class="crm-card-info__header">
              <h2 class="crm-card-info__title">{{ 'about_deal' | translate }}</h2>
            </div>
            <div class="crm-card-info__section">
              <div class="crm-card-info__label">{{ 'phase' | translate }}</div>
              @if (loaders.card) {
                <ngx-skeleton-loader [theme]="{ width: '100px' }" />
              }
              @if (card && !card.column.editable) {
                <div class="crm-card-info__value" (click)="editField(card.column)">{{ card.column.name }}</div>
              }
              @if (card && card.column.editable) {
                <app-dropdown
                  [items]="columns"
                  [bindValue]="'id'"
                  [closeOnSelect]="true"
                  [formControl]="cardForm.controls.column_id"
                />
              }
            </div>
            <div class="crm-card-info__section">
              <div class="crm-card-info__label">{{ 'amount_and_currency' | translate }}</div>
              @if (loaders.card) {
                <ngx-skeleton-loader [theme]="{ width: '100px' }" />
              }
              @if (card && !card.editable) {
                <div (click)="editField(card)" class="crm-card-info__value">{{ card.price }} {{ card.currency }}</div>
              }
              @if (card && card.editable) {
                <div class="crm-card-edit-price">
                  <app-text-field [formControl]="cardForm.controls.price" />
                  <app-dropdown
                    [items]="CURRENCY_CODE"
                    [bindLabel]="'name'"
                    [bindLabelOption]="'name'"
                    [bindValue]="'value'"
                    [closeOnSelect]="true"
                    [formControl]="cardForm.controls.currency"
                  />
                </div>
              }
            </div>
            <div class="crm-card-info__section">
              <div class="crm-card-info__label">{{ 'created_at' | translate }}</div>
              @if (loaders.card) {
                <ngx-skeleton-loader [theme]="{ width: '100px' }" />
              }
              @if (card) {
                <div class="crm-card-info__value">{{ card.created_at | date: 'LLL MM, yyyy' }}</div>
              }
            </div>
            <div class="crm-card-info__section">
              <div class="crm-card-info__label">{{ 'updated_at' | translate }}</div>
              @if (loaders.card) {
                <ngx-skeleton-loader [theme]="{ width: '100px' }" />
              }
              @if (card) {
                <div class="crm-card-info__value">{{ card.updated_at | date: 'LLL MM, yyyy' }}</div>
              }
            </div>
            <div class="crm-card-info__section">
              <div class="crm-card-info__label">{{ 'client' | translate }}</div>
              <div class="crm-card-info__value text-lowercase">{{ 'not_filled' | translate }}</div>
            </div>
            <!--          <div class="crm-card-info__actions">-->
            <!--            <button class="crm-card-info__action-btn">Выбрать поле</button>-->
            <!--            <button class="crm-card-info__action-btn">Создать поле</button>-->
            <!--            <button class="crm-card-info__action-btn">Удалить раздел</button>-->
            <!--          </div>-->
          </div>
          <div class="crm-card-info">
            <div class="crm-card-info__header">
              <h2 class="crm-card-info__title">{{ 'additional_information' | translate }}</h2>
            </div>
            @if (loaders.customAttributes) {
              <div class="crm-card-info__section">
                <div class="crm-card-info__label">
                  <ngx-skeleton-loader [theme]="{ width: '100px' }" />
                </div>
                <div class="crm-card-info__value">
                  <ngx-skeleton-loader [theme]="{ width: '100px' }" />
                </div>
              </div>
            }
            @for (ca of customAttributes; track ca) {
              <div class="crm-card-info__section">
                <div class="crm-card-info__label">{{ ca.title }}</div>
                @if (loaders.card) {
                  <ngx-skeleton-loader [theme]="{ width: '100px' }" />
                }
                @if (card && !ca.editable) {
                  <div (click)="editField(ca)" class="crm-card-info__value">
                    {{ card.custom_attributes[ca.key] || '-' }}
                  </div>
                }
                @if (ca.editable) {
                  <app-text-field
                    [autofocus]="true"
                    [formControl]="cardForm.controls.custom_attributes.controls[ca.key]"
                  />
                }
              </div>
            }
          </div>
        </div>
      }
    }
  }

  @if (isEditCard) {
    <div class="crm-card-save-container">
      <app-button (click)="onSave()">{{ 'save' | translate }}</app-button>
      <app-button btnType="stroked" (click)="onCancel()">{{ 'cancel' | translate }}</app-button>
    </div>
  }
</div>
